export const locale = {
  en: {
    message: 'test001',
    list: 'List'
  }
}
